import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { MatrizConstatacoesService } from "../../../../../services/matriz-constatacao.service";
import { IAvaliarManifestacaoDto } from "../../../../../models/constatacao.model";
import { AuthService } from "../../../../../services/auth.service";

@Component({
  selector: 'app-modal-avaliar-manifestacao',
  templateUrl: './modal-avaliar-manifestacao.component.html',
  styleUrls: ['./modal-avaliar-manifestacao.component.scss']
})
export class ModalAvaliarManifestacaoComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  public manifestacaoID: number;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModalAvaliarManifestacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private matrizService: MatrizConstatacoesService
  ) {

    this.manifestacaoID = data?.manifestacao?.id ?? data?.id ?? 0;

    if (!this.manifestacaoID) {
      console.error('manifestacaoID não resolvido, data recebido:', data);
    }
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      avaliacaoTipo: ['', Validators.required],
      comentario: ['', [Validators.required, Validators.maxLength(500)]]
    });
  }

  public avaliar(): void {
    if (!this.form.valid) {
      this.exibirAviso('Preencha todos os campos obrigatórios');
      return;
    }

    this.loading = true;
    const dto: IAvaliarManifestacaoDto = {
      manifestacaoAuditadoId: this.manifestacaoID,
      avaliacaoTipo: this.form.value.avaliacaoTipo,
      comentario: this.form.value.comentario,
      usuarioAvaliacaoId: this.authService.usuario.id
    };

    this.matrizService.avaliarManifestacaoAuditado(dto)
      .then(res => {
        if (res.sucesso) {
          this.exibirSucesso('Manifestação avaliada com sucesso');

          // Dispara o callback para atualizar o modal de manifestação ainda aberto
          if (this.data?.onEvaluated) {
            this.data.onEvaluated();
          }

          this.dialogRef.close(true);
        } else {
          const mensagem = res?.mensagem?.descricao || 'Erro ao avaliar manifestação';
          this.exibirErro(mensagem);
        }
      })
      .catch(err => {
        const mensagem = err?.mensagem?.descricao || 'Erro ao avaliar manifestação';
        this.exibirErro(mensagem);
      })
      .finally(() => this.loading = false);
  }

  public fechar(): void {
    this.dialogRef.close();
  }

  private exibirSucesso(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      text: mensagem,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    });
  }
  private exibirAviso(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'warning',
      text: mensagem,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true
    });
  }

  private exibirErro(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      text: mensagem,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true
    });
  }
}
